"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _skill = require("./skill");

var model = {
  id: "cleric3",
  tier: 3,
  isEnabled: true,
  i18nName: {
    en: "Cleric 3"
  },
  iconFileName: "consskill3.gif",
  soundFileName: "TODO",
  classSkillModels: [_skill.classSkillModel, _skill.classSkillModel]
};
var skillCombo = {
  model: model,
  id: 234234234,
  usedCount: 1,
  windowPage: 1,
  windowPosX: 1,
  windowPosY: 1
};
var _default = skillCombo;
exports.default = _default;